import styled from 'styled-components';
import Select from 'react-select';

export const AddPropertyMortgageeContainer = styled.div.attrs({
  id: 'AddPropertyMortgageeContainer',
})`
  margin-top: 16px;
  width: 100%;
`;
export const TwoColumnContainer = styled.div.attrs({})`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  @media (max-width: 449px) {
  }
  @media (min-width: 450px) and (max-width: 699px) {
  }
  @media (min-width: 700px) and (max-width: 1279px) {
  }
  @media (min-width: 1280px) {
  }
`;
export const AddPropertyMortgageeField = styled.div.attrs({
  id: 'addpropertymortgageefieldcontainer',
})`
  min-width: 200px;
  width: 50%;
  @media (max-width: 599px) {
    width: 100%;
  }
`;

export const AddPropertyMortgageeFieldHeader = styled.h4.attrs({
  id: 'AddPropertyMortgageeFieldHeader',
})`
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-size: 0.9rem;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeSpeed;
  margin-bottom: 8px;
  @media (max-width: 599px) {
  }
  @media (min-width: 600px) and (max-width: 959px) {
  }
  @media (min-width: 900px) and (max-width: 1279px) {
  }
  @media (min-width: 1280px) {
  }
`;
export const RequiredField = styled.span.attrs({})`
  color: red;
`;
export const AddMortgageeButtonsContainer = styled.div.attrs({})`
  text-align: right;
  margin-right: 2%;
  @media (max-width: 384px) {
    margin-top: 5px;
    text-align: center;
  }
`;
export const AddMortgageeButton = styled.button.attrs({})`
  margin-top: 10px;
  margin-left: 10px;
  padding: 10px 20px;
  background-color: ${(props) => props.theme.primaryColor};
  color: white;
  :disabled {
    background-color: gray;
  }
  @media (max-width: 384px) {
    margin-bottom: 5px;
  }
`;
export const AddMortgageeTextAreaField = styled.textarea.attrs({
  id: 'ReportClaimsTextInputField',
})`
  height: 100px;
  margin-top: 5px;
  margin-bottom: 10px;
  width: 100%;
  @media (max-width: 599px) {
  }
  @media (min-width: 600px) and (max-width: 959px) {
  }
  @media (min-width: 900px) and (max-width: 1279px) {
  }
  @media (min-width: 1280px) {
  }
`;
export const AddMortgageeSubHeader = styled.h4.attrs({
  id: 'addMortgageeSubHeader',
})`
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-size: 1.001rem;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeSpeed;
  @media (max-width: 599px) {
  }
  @media (min-width: 600px) and (max-width: 959px) {
  }
  @media (min-width: 900px) and (max-width: 1279px) {
  }
  @media (min-width: 1280px) {
  }
`;
export const AddMortgageeTextInputField = styled.input.attrs({
  type: 'text',
})`
  height: 30px;
  width: 100%;
  @media (max-width: 599px) {
  }
  @media (min-width: 600px) and (max-width: 959px) {
  }
  @media (min-width: 900px) and (max-width: 1279px) {
  }
  @media (min-width: 1280px) {
  }
`;
export const AddMortgageeStateSelectorContainer = styled.div.attrs({
  id: 'AddMortgageeStateSelectorContainer',
})`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  margin-top: 16px;
  margin-bottom: 16px;

  @media (max-width: 599px) {
  }
  @media (min-width: 600px) and (max-width: 699px) {
  }
  @media (min-width: 700px) and (max-width: 1279px) {
  }
  @media (min-width: 1280px) {
  }
`;

export const RadioAddressLabel = styled.div.attrs({})`
  display: inline-block;
  margin-left: 8px;
`;
export const AddMortgageePropertyComponent = styled.div.attrs({})`
  margin-bottom: 12px;
`;
export const AddMortgageeRadioButton = styled.input.attrs({
  type: 'radio',
})`
  display: inline-block;
  vertical-align: top;
  margin-top: 12px;
`;
export const MortgageeInterestTypesList = styled(Select).attrs({
  id: 'mortgageeInterestTypesList',
})`
  margin: 10px 0 0 16px;
`;
export const EscrowContainer = styled.div`
  width: 70%;
  @media (max-width: 599px) {
    width: 100%;
  }
  @media (min-width: 600px) and (max-width: 959px) {
    width: 75%;
  }
`;
